import { Plugins } from '@leverege/plugin'

import ComplexPasswordValidator from './ComplexPasswordValidator.js'

const PasswordValidatorFactory = Plugins.createFactory( 'PasswordValidator', {
  strategy : Plugins.ALL,
  pluginKey : 'validator',
  defaultObject : ComplexPasswordValidator
} )

export {
  // eslint-disable-next-line import/prefer-default-export
  PasswordValidatorFactory
}
